
import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import styled from 'styled-components';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing,
    getLineHeight,
} from '@process-advisor/process-miner/shared/theme';

const RadioComponent = styled(Radio)<{ checked?: boolean }>`
    color: ${({ checked }) =>
        checked
            ? getColor('lightBlue')
            : getColor('lightBorderColor')};

    height: 25px;
    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;

const StyledFormControlLabel = styled(FormControlLabel)`
    margin-right: 30px;
    height: 25px;

    & .MuiFormControlLabel-label {
        color: ${getColor('inputTextColor')};
        font-family: ${getFontFamily('atlassian')};
        font-size: ${getFontSize('smaller')};
        letter-spacing: ${getLetterSpacing('small')};
        line-height: ${getLineHeight('small')};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const Wrapper = styled.div`

`;

export const StepWidth = () => {
    const [value, setValue] = React.useState('tasks');
    const [label, setLabel] = React.useState('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        const selectAction = (event.target as HTMLInputElement).value;
        setValue(selectAction);
        apiProvider.changeStepWidth({
            tasks: selectAction === 'tasks',
            duration: selectAction === 'duration',
            std_deviation: selectAction === 'std_deviation',
        });
        if (apiProvider.getActiveAction() === 'process_miner') apiProvider.rebuildPVDiagram({});
    };

    React.useEffect(() => {
        const listener = () => {
            const settings = apiProvider.getStepWidth()
            if (settings.tasks === true) {setValue('tasks');}
            if (settings.duration === true) {setValue('duration');}
            if (settings.std_deviation === true) {setValue('std_deviation');}
        };

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    React.useEffect(() => {
        const listener = () => {
            const settings = apiProvider.getStepWidth()
            if (settings.tasks === true) {setValue('tasks');}
            if (settings.duration === true) {setValue('duration');}
            if (settings.std_deviation === true) {setValue('std_deviation');}
        };

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    React.useEffect(() => {
        setLabel(apiProvider.getEntityUpper() + 's')
    }, []);

    return (
        <Wrapper>
            <RadioGroup
                row
                aria-label="selectAction"
                name="selectAction"
                value={value}
                onChange={handleChange}>
                <StyledFormControlLabel
                    value="tasks"
                    control={<RadioComponent />}
                    label={label} />                    
                <StyledFormControlLabel
                    value="duration"
                    control={<RadioComponent />}
                    label="Avg Duration" />
                <StyledFormControlLabel
                    value="std_deviation"
                    control={<RadioComponent />}
                    label="Std Deviation" />
            </RadioGroup>
        </Wrapper>
    );
};
